import { motion, useReducedMotion } from "framer-motion";

/**
 * Painterly image with hover-to-zoom + optional Ken-Burns idle.
 * Provides a warm painterly fallback panel if the image fails to load.
 */
export default function Painting({
  src,
  alt,
  className = "",
  wrapperClassName = "",
  kenBurns = false,
  parallaxY = 0,
  clip = "rounded-[6px]",
  onError,
}) {
  const reduce = useReducedMotion();
  return (
    <div
      className={[
        "relative overflow-hidden zoom-cursor bg-parchment",
        "shadow-[0_30px_60px_-30px_hsl(var(--earth)/0.4)]",
        "ring-1 ring-earth/10",
        clip,
        wrapperClassName,
      ].join(" ")}
    >
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        onError={onError}
        initial={reduce ? { scale: 1 } : { scale: 1.02 }}
        animate={
          kenBurns && !reduce
            ? { scale: [1.02, 1.12], x: [0, -12], y: [0, -8] }
            : { scale: 1 }
        }
        transition={
          kenBurns && !reduce
            ? { duration: 22, ease: "easeOut", repeat: 0 }
            : { duration: 1.2, ease: "easeOut" }
        }
        whileHover={reduce ? undefined : { scale: 1.06 }}
        style={{ y: parallaxY }}
        className={[
          "block h-full w-full object-cover transition-[filter] duration-700",
          "will-change-transform",
          className,
        ].join(" ")}
      />
      {/* painterly warm wash */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, hsl(var(--gold)/0.05) 0%, transparent 30%, transparent 70%, hsl(var(--earth)/0.18) 100%)",
        }}
      />
    </div>
  );
}
